import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/layout/sidebar/lllustrations/logo-general-center-text.svg'
import _imports_1 from '@/app/ui/views/setup-password/assets/error-token.svg'


const _hoisted_1 = { class: "flex flex-col items-center justify-center w-max gap-y-8" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-auto h-16",
  alt: "logo"
}, null, -1)
const _hoisted_3 = { class: "flex flex-col gap-y-2 flex-1 items-center justify-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-auto h-36",
  alt: "expired"
}, null, -1)
const _hoisted_5 = { class: "font-bold text-black text-2xl flex-1 text-center" }
const _hoisted_6 = { class: "pt-10 w-full flex items-center justify-center relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelpCenter = _resolveComponent("HelpCenter")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: "px-28 py-10 flex-grow flex flex-col min-h-0",
    rounded: "2xl"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("h1", _hoisted_5, _toDisplayString(_ctx.tokenResponseData.title), 1),
          _createVNode("div", {
            class: "text-xl font-medium text-gray-lp-800 px-17 text-center flex-1",
            innerHTML: _ctx.tokenResponseData.message
          }, null, 8, ["innerHTML"])
        ]),
        (_ctx.tokenResponseData.title)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              "data-testid": "auth-setup-password-error-button-cta",
              type: "submit",
              class: "bg-red-lp-100 cursor-pointer text-white py-2 font-semibold rounded-md focus:outline-none shadow text-center w-400px",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.tokenResponseData.onSubmit && _ctx.tokenResponseData.onSubmit(...args)))
            }, _toDisplayString(_ctx.tokenResponseData.textSuccess), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_HelpCenter),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Footer)
        ])
      ])
    ]),
    _: 1
  }))
}